import React, { useEffect } from "react";
import useGetMyManagement from "services/management/useGetMyManagement";
import LoaderMin from "components/blocks/Loader/LoaderMin";
import { useGeneralManagementState } from "../GeneralManagement/generalManagementState";
import DocumentsAuthorizationsGrid from "components/blocks/Grids/DocumentsAuthorizationsGrid";
import useGetAllAuthorizations from "services/management/useGetAllAuthorizations";
import Icon from "components/blocks/Icon/Icon";
import NoData from "components/pages/noData/NoData";

// subsection: "forms" | "docs" | null
// When null, component mounts (triggering data fetch) but renders nothing visible.
const ManagementAuthorizations = ({ handleOnClick, subsection }) => {
  const { state, dispatch } = useGeneralManagementState();
  const {
    getMyManagement,
    successGetMyManagement,
    dataMyManagement,
    formulariosAutorizaciones,
  } = useGetMyManagement();
  const {
    allGetAllAuthorizations,
    getAllAuthorizations,
    successGetAllAuthorizations,
    loadingGetAllAuthorizations
  } = useGetAllAuthorizations();
  const { prestacionActiva } = state;

  useEffect(() => {
    if (formulariosAutorizaciones.length <= 0) {
      getMyManagement();
    }
    getAllAuthorizations();
  }, []);

  useEffect(() => {
    if (state.formulariosAutorizaciones <= 0) {
      dispatch({ type: "SET_FORMS_AUTORIZACIONES", payload: formulariosAutorizaciones });
      dispatch({ type: "SET_DOCUMENTOS_AUTORIZACIONES", payload: allGetAllAuthorizations });
    }
  }, [dataMyManagement]);

  // ── Formularios Autorizaciones ──────────────────────────────────────────────
  if (subsection === "forms") {
    return (
      <>
        {loadingGetAllAuthorizations && (
          <div className="mgmt-loading"><LoaderMin /></div>
        )}

        {!loadingGetAllAuthorizations &&
          successGetMyManagement &&
          state.formulariosAutorizaciones?.length === 0 && (
          <NoData message="No hay formularios de autorizaciones" />
        )}

        {state.formulariosAutorizaciones?.length > 0 && (
          <div className="mgmt-cards-grid">
            {state.formulariosAutorizaciones.map((autorizacion, i) =>
              autorizacion.Tipo === 1 ? (
                <article
                  key={`auth_form_${i}`}
                  className="mgmt-item-card"
                  onClick={() => handleOnClick(autorizacion.Titulo, autorizacion.Url)}
                >
                  <div className="mgmt-item-card__icon">
                    <Icon name="external" size={20} />
                  </div>
                  <div className="mgmt-item-card__body">
                    <div className="mgmt-item-card__title">{autorizacion.Titulo}</div>
                    {autorizacion.Descripcion && (
                      <div className="mgmt-item-card__desc">{autorizacion.Descripcion}</div>
                    )}
                  </div>
                  <div className="mgmt-item-card__action">
                    <span className="mgmt-item-card__btn">
                      Ver <Icon name="arrow-right" size={13} />
                    </span>
                  </div>
                </article>
              ) : (
                <article key={`auth_pdf_${i}`} className="mgmt-item-card mgmt-item-card--static">
                  <div className="mgmt-item-card__icon mgmt-item-card__icon--download">
                    <Icon name="download" size={20} />
                  </div>
                  <div className="mgmt-item-card__body">
                    <div className="mgmt-item-card__title">{autorizacion.Titulo}</div>
                    {autorizacion.Descripcion && (
                      <div className="mgmt-item-card__desc">{autorizacion.Descripcion}</div>
                    )}
                  </div>
                  <div className="mgmt-item-card__action">
                    <a href={autorizacion.Url} rel="noopener noreferrer" className="mgmt-item-card__btn">
                      Descargar PDF <Icon name="download" size={13} />
                    </a>
                  </div>
                </article>
              )
            )}
          </div>
        )}
      </>
    );
  }

  // ── Documentos Autorizaciones ───────────────────────────────────────────────
  if (subsection === "docs") {
    return (
      <>
        {loadingGetAllAuthorizations && (
          <div className="mgmt-loading"><LoaderMin /></div>
        )}

        {!loadingGetAllAuthorizations &&
          successGetAllAuthorizations &&
          allGetAllAuthorizations?.length === 0 && (
          <NoData message="No hay documentos de autorizaciones" />
        )}

        {allGetAllAuthorizations && allGetAllAuthorizations.length > 0 && (
          <DocumentsAuthorizationsGrid documents={allGetAllAuthorizations} />
        )}
      </>
    );
  }

  // subsection === null → component mounts for data fetching but renders nothing
  return null;
};

export default ManagementAuthorizations;
